import { CustomFieldValueVoData } from "../../";
import { CheckUtils } from "../../index";
var CustomFieldValueConverter = /** @class */ (function () {
    function CustomFieldValueConverter() {
    }
    CustomFieldValueConverter.convertToCustomFieldValueVoDataArray = function (customFieldValueMap) {
        var cfValues = [];
        if (!CheckUtils.isEmpty(customFieldValueMap)) {
            for (var _i = 0, customFieldValueMap_1 = customFieldValueMap; _i < customFieldValueMap_1.length; _i++) {
                var value = customFieldValueMap_1[_i];
                cfValues.push(this.convertToCustomFieldValueVoData(value));
            }
        }
        return cfValues;
    };
    CustomFieldValueConverter.convertToCustomFieldValueVoData = function (customFieldValue) {
        var value = new CustomFieldValueVoData(customFieldValue.id);
        value.isDefault = customFieldValue.isDefault;
        value.order = customFieldValue.order;
        value.value = customFieldValue.value;
        return value;
    };
    return CustomFieldValueConverter;
}());
export { CustomFieldValueConverter };
//# sourceMappingURL=custom-field-value-converter.js.map


//////////////////
// WEBPACK FOOTER
// ../od-ts/dist/utils/converter/custom-field-value-converter.js
// module id = 405
// module chunks = 14